import { FormGroup } from '@angular/forms';
import { rx, Observable, observableMerge } from '@shared/rx';
import { IWidgetAction, XUX_FORM_ACTIONS } from './schema-form-interfaces';

export const createFormActionObs = (
  form: FormGroup,
): Observable<IWidgetAction> => {
  const changeValueActionObs: Observable<IWidgetAction> =
    form.valueChanges.pipe(
      rx.map(
        (value) =>
          ({
            type: XUX_FORM_ACTIONS.FORM_VALUE_CHANGED,
            fieldPath: '',
            payload: { value },
          }) as any,
      ),
    );

  const changeStatusActionObs: Observable<IWidgetAction> =
    form.statusChanges.pipe(
      rx.map(
        (status) =>
          ({
            type: XUX_FORM_ACTIONS.FORM_STATUS_CHANGED,
            fieldPath: '',
            payload: {
              status,
              dirty: form.dirty,
              touched: form.touched,
              valid: form.valid,
            },
          }) as any,
      ),
    );

  return observableMerge(
    changeValueActionObs.pipe(rx.debounceTime(0)),
    changeStatusActionObs.pipe(rx.debounceTime(0)),
  );
};
